var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    width: 20,
    fill: "#7f8090",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 15.667H6.917Q6.188 15.667 5.677 15.156Q5.167 14.646 5.167 13.917V2.604Q5.167 1.875 5.677 1.365Q6.188 0.854 6.917 0.854H11.729Q12.083 0.854 12.406 0.99Q12.729 1.125 12.979 1.375L16.979 5.375Q17.229 5.625 17.365 5.948Q17.5 6.271 17.5 6.625V13.917Q17.5 14.646 16.99 15.156Q16.479 15.667 15.75 15.667ZM3.417 19.167Q2.688 19.167 2.177 18.656Q1.667 18.146 1.667 17.417V6.896Q1.667 6.542 1.927 6.281Q2.188 6.021 2.542 6.021Q2.896 6.021 3.156 6.281Q3.417 6.542 3.417 6.896V17.417Q3.417 17.417 3.417 17.417Q3.417 17.417 3.417 17.417H11.458Q11.812 17.417 12.073 17.677Q12.333 17.938 12.333 18.292Q12.333 18.646 12.073 18.906Q11.812 19.167 11.458 19.167ZM12.458 6.771H15.75L11.583 2.604V5.896Q11.583 6.25 11.844 6.51Q12.104 6.771 12.458 6.771Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.cac6ae8e.svg";
export { ForwardRef as ReactComponent };